module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/facebook-5259a8680b9d4f77761b81636f24eae5.svg";